// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dhoAezwv2QIhpzjIA_jK{flex-direction:column;justify-content:center;align-items:center;gap:20px;height:240px;display:flex}.dhoAezwv2QIhpzjIA_jK .VsvrnA1ljMl6wFP4SK9W{flex-direction:column;align-items:center;gap:4px;display:flex}.dhoAezwv2QIhpzjIA_jK .xawpM3Ha6dQvrSE02ml7{text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `dhoAezwv2QIhpzjIA_jK`,
	"block": `VsvrnA1ljMl6wFP4SK9W`,
	"desc": `xawpM3Ha6dQvrSE02ml7`
};
export default ___CSS_LOADER_EXPORT___;
